import React, { useEffect, useState } from "react";
import { useUserLocation } from "../../providers/LocationProvider"
import "./LocationConsent.css";

const LocationConsent = () => {
    const { setLocation } = useUserLocation();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("location_consent");

    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAllow = () => {
    localStorage.setItem("location_consent", "granted");

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          localStorage.setItem("user_location", JSON.stringify(coords));
          setLocation(coords);
          console.log("Location saved:", coords);
        },
        (error) => {
          console.error("Location error:", error);
        }
      );
    }

    setVisible(false);
  };

  const handleDeny = () => {
    localStorage.setItem("location_consent", "denied");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="location-banner">
      <p>
        Allow location access to find tutors and training centers near you.
      </p>

      <div className="location-buttons">
        <button className="allow-btn" onClick={handleAllow}>
          Allow
        </button>
        <button className="deny-btn" onClick={handleDeny}>
          Not Now
        </button>
      </div>
    </div>
  );
};

export default LocationConsent;